import { __awaiter, __decorate, __extends, __generator, __metadata } from "tslib";
import { injectable } from 'tsyringe';
import { fetchSiteFeatures } from '@gn-audio/core/api/site-settings/fetch-site-features';
import { createElement } from '@gn-audio/core/common/templating';
import { BasketPlugin } from '../../models';
import { SFCCBasketService } from '../../services/sfcc-basket.service';
import { emulateClickWhenEnterOrSpacePressed, getBasketTotalCount, getBasketUrl } from '../../utilities';
import { BasketEmailContentComponent } from './components';
import './basket-email.plugin.scss';
import template from './basket-email.plugin.html';
var BasketEmailPlugin = /** @class */ (function (_super) {
    __extends(BasketEmailPlugin, _super);
    function BasketEmailPlugin(sfccBasketService) {
        var _this = _super.call(this) || this;
        _this.sfccBasketService = sfccBasketService;
        _this.handleKeysPressesOnElement = function (event) {
            emulateClickWhenEnterOrSpacePressed(event, _this.element);
        };
        _this.hideContent = function () {
            _this.content.hide();
            _this.overlay.classList.remove("visible" /* CssClass.Visible */);
        };
        _this.hideUI = function () {
            _this.hideContent();
            _this.element.classList.remove("focused" /* CssClass.Focused */, "visible" /* CssClass.Visible */);
        };
        _this.showUI = function () {
            _this.element.classList.add("visible" /* CssClass.Visible */);
        };
        _this.onToggleUI = function () {
            _this.content.toggle();
            _this.overlay.classList.toggle("visible" /* CssClass.Visible */);
            _this.element.classList.toggle("focused" /* CssClass.Focused */);
        };
        _this.onSubmit = function (email) { return __awaiter(_this, void 0, void 0, function () {
            var contentWindow;
            var _this = this;
            return __generator(this, function (_a) {
                this.eventBus.post("show-loader-ui" /* BasketEvent.ShowLoaderUI */);
                this.iframe = document.createElement('iframe');
                this.iframe.src = '/email-basket';
                this.iframe.style.display = 'none';
                document.body.appendChild(this.iframe);
                contentWindow = this.iframe.contentWindow;
                contentWindow.addEventListener('DOMContentLoaded', function () { return __awaiter(_this, void 0, void 0, function () {
                    var basketCustomObjectKey, form, emailInput, productsInput, error_1;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _b.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, this.sfccBasketService.createSharedBasket(this.state)];
                            case 1:
                                basketCustomObjectKey = _b.sent();
                                form = contentWindow.document.querySelector('.jbr-form form');
                                emailInput = form.querySelector('.email-field input[type="text"]');
                                emailInput.value = email;
                                productsInput = form.querySelector('.basket-hidden-url-field input[type="text"]');
                                productsInput.value = getBasketUrl(basketCustomObjectKey);
                                form.submit();
                                (_a = this.content) === null || _a === void 0 ? void 0 : _a.showThankYou();
                                return [3 /*break*/, 3];
                            case 2:
                                error_1 = _b.sent();
                                console.warn(error_1);
                                return [3 /*break*/, 3];
                            case 3:
                                this.eventBus.post("hide-loader-ui" /* BasketEvent.HideLoaderUI */);
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        _this.reactOnChanges = function (state) {
            var _a;
            _this.state = state;
            (_a = _this.iframe) === null || _a === void 0 ? void 0 : _a.remove();
            _this.content.reset();
            _this.element.classList.remove("focused" /* CssClass.Focused */);
            var totalCount = getBasketTotalCount(state);
            if (totalCount === 0) {
                _this.hideUI();
            }
            else {
                _this.showUI();
                _this.hideContent();
            }
        };
        return _this;
    }
    BasketEmailPlugin.prototype.register = function (_a) {
        var eventBus = _a.eventBus, state = _a.state, translations = _a.translations;
        return __awaiter(this, void 0, void 0, function () {
            var container;
            return __generator(this, function (_b) {
                this.eventBus = eventBus;
                container = document.querySelector(".basket-ui__header" /* BasketUIElementSelector.BasketHeader */);
                this.element = createElement(template, {}, translations);
                container.appendChild(this.element);
                this.element.addEventListener('click', this.onToggleUI);
                this.element.addEventListener('keydown', this.handleKeysPressesOnElement);
                this.eventBus.subscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnChanges);
                this.content = new BasketEmailContentComponent();
                this.content.render({ container: container, onSubmit: this.onSubmit, translations: translations });
                this.overlay = document.createElement('div');
                this.overlay.classList.add('basket-email-overlay');
                document.querySelector(".basket-ui__footer" /* BasketUIElementSelector.BasketFooter */)
                    .insertAdjacentElement('afterend', this.overlay);
                this.overlay.addEventListener('click', this.onToggleUI);
                this.reactOnChanges(state);
                return [2 /*return*/];
            });
        });
    };
    BasketEmailPlugin.prototype.shouldRegister = function () {
        return __awaiter(this, void 0, void 0, function () {
            var featureToggles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchSiteFeatures(["SfccBasketSendByEmail" /* SiteFeature.SfccBasketSendByEmail */])];
                    case 1:
                        featureToggles = _a.sent();
                        return [2 /*return*/, featureToggles.length > 0 && !!featureToggles[0].value];
                }
            });
        });
    };
    BasketEmailPlugin.prototype.unregister = function () {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_f) {
                (_a = this.overlay) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', this.onToggleUI);
                (_b = this.overlay) === null || _b === void 0 ? void 0 : _b.remove();
                (_c = this.element) === null || _c === void 0 ? void 0 : _c.removeEventListener('click', this.onToggleUI);
                (_d = this.element) === null || _d === void 0 ? void 0 : _d.removeEventListener('keydown', this.handleKeysPressesOnElement);
                this.eventBus.unsubscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnChanges);
                this.content.destroy();
                (_e = this.element) === null || _e === void 0 ? void 0 : _e.remove();
                return [2 /*return*/];
            });
        });
    };
    BasketEmailPlugin = __decorate([
        injectable(),
        __metadata("design:paramtypes", [SFCCBasketService])
    ], BasketEmailPlugin);
    return BasketEmailPlugin;
}(BasketPlugin));
export { BasketEmailPlugin };
